import { render, staticRenderFns } from "./HelpComment.vue?vue&type=template&id=c69404ba&"
import script from "./HelpComment.vue?vue&type=script&lang=js&"
export * from "./HelpComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports